/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';

import template from './campaign-analysis-page.component.html';
import {campaignCommons} from './campaign-commons';

@Component({
  standalone: false,
  selector: 'adn-campaign-analysis-page',
  template
})
export class CampaignAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  @Input() unrejectError = false;

  private _lir: any;
  private _modelCommsDirect: any;
  private _isNewDirect: boolean | undefined;

  @Input()
  set lir(value: any) {
    this._lir = value;
    this.syncCreatives();
  }

  get lir(): any {
    return this._lir;
  }

  @Input()
  set modelComms(value: any) {
    this._modelCommsDirect = value;
  }

  get modelComms(): any {
    return this._modelCommsDirect;
  }

  @Input()
  set isNew(value: boolean) {
    this._isNewDirect = value;
  }

  get isNew(): boolean {
    return this._isNewDirect;
  }

  @Output() unrejectCreative = new EventEmitter<any>();
  @Output() editCreativeTarget = new EventEmitter<{targeting: any; creative: any}>();

  effectiveIsNew = false;
  activeTab: 'creative' | 'statistics' = 'creative';
  activeCreativeIndex = 0;
  showingChart: string | null = null;
  creatives: any[] = [];
  maxWidth = 100;
  maxHeight = 100;

  private subscribedModelComms: any;

  constructor(private readonly cdr: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.lir) {
      this.syncCreatives();
    }
    if (changes.modelComms) {
      this.subscribeModelComms();
    }
  }

  selectCreativeTab(index: number): void {
    this.activeTab = 'creative';
    this.activeCreativeIndex = index;
    this.showingChart = null;
  }

  selectStatistics(): void {
    this.activeTab = 'statistics';
    this.showingChart = 'LINE_ITEM';
  }

  onUnreject(creative: any): void {
    this.unrejectCreative.emit(creative);
  }

  onEditCreativeTarget(targeting: any, creative: any): void {
    this.editCreativeTarget.emit({targeting, creative});
  }

  trackCreative(index: number, creative: any): any {
    return creative?.creative?.id || creative?.id || index;
  }

  private syncCreatives(): void {
    const next = _.get(this._lir, 'creatives');
    this.creatives = Array.isArray(next) ? next : [];
    if (this._lir) {
      campaignCommons(this).setUpComponents(['lir']);
    }
  }

  private subscribeModelComms(): void {
    if (!this.modelComms || this.subscribedModelComms === this.modelComms) {
      return;
    }
    this.subscribedModelComms = this.modelComms;
    // Route/edit isNew may lag; modelComms is the post-save source of truth.
    this.modelComms.addSubscriber((data: any, type: any, isNewFromComms?: boolean) => {
      if (type) {
        return;
      }
      if (isNewFromComms === true || isNewFromComms === false) {
        this.effectiveIsNew = isNewFromComms;
      } else if (data?.name) {
        this.effectiveIsNew = false;
      }
      this.cdr.markForCheck();
    });
  }
}
